import React from "react";
import Calendly from "../../../components/Calendly/Calendly";
import Layout from "../../Layouts/Layout";
import { useCustomer } from "../../../provider/Customer/CustomerProvider";
import { getCustomerConsent } from "../../../services/customerService";
import RecordingConsentForm from "../../../components/Form/Common/RecordingConsent/RecordingConsentForm";
import Container from "../../../components/Container/Container";

const CalendlyPage = ({}) => {
  const { customer } = useCustomer();

  const consent = customer ? getCustomerConsent(customer, "callRecordingAndSummary") : null;

  return (
    <Layout>
      {consent && <Calendly />}
      {!consent && (
        <Container>
          <RecordingConsentForm handleConsent={(state: string) => {}} />
        </Container>
      )}
    </Layout>
  );
};

export default CalendlyPage;
